import React from "react";
import { motion } from "framer-motion";

const PTA = () => {
  // Cloudinary image URL (main card image)
  const cloudinaryImageUrl =
    "https://res.cloudinary.com/ddvpczzng/image/upload/v1757497482/2_cyxqvi.png";

  return (
    <section
      className="relative w-screen left-1/2 right-1/2 mx-[-50vw] overflow-hidden 
      -mt-12 md:-mt-16 lg:-mt-20 
      mb-[-48px] md:mb-[-64px] lg:mb-[-80px] 
      pt-16 md:pt-20 lg:pt-24 
      pb-16 md:pb-20 lg:pb-24"
      aria-labelledby="pta-heading"
    >
      {/* 🔹 Full-width Background */}
      <div
        className="absolute inset-0 bg-cover bg-center brightness-75"
        style={{
          backgroundImage:
            "url('https://tgaa.in/wp-content/uploads/2022/09/GreenAcres2019-Web-002-scaled.jpg')",
        }}
        aria-hidden="true"
      ></div>
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        aria-hidden="true"
      ></div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center">
        {/* Visually hidden heading to name the section */}
        <h2 id="pta-heading" className="sr-only">
          Parent Teacher Association
        </h2>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex flex-col lg:flex-row-reverse items-center gap-6 sm:gap-8 lg:gap-12 max-w-6xl w-full 
          border-2 border-pink-300 rounded-3xl shadow-xl 
          bg-white/20 backdrop-blur-sm p-6 sm:p-8 lg:p-12"
        >
          {/* Left Side - Message Card */}
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="relative bg-white px-6 py-8 sm:px-8 sm:py-10 rounded-3xl shadow-lg w-full 
            transition-all duration-300 hover:shadow-pink-300/50"
          >
            {/* Top Quote inside card */}
            <span
              className="absolute top-4 left-4 text-6xl text-pink-400 font-serif hidden sm:block"
              aria-hidden="true"
            >
              “
            </span>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4 text-gray-900">
              Through <span className="text-amber-600">PTA</span>,
            </h2>
            <div className="space-y-3 sm:space-y-4">
              <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed sm:leading-loose">
                we create a supportive network where every voice matters in the
                journey of a child's growth.
              </p>
              <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed sm:leading-loose">
                We foster open communication between parents and educators to
                ensure a nurturing environment.
              </p>
            </div>

            {/* Bottom Quote inside card */}
            <span
              className="absolute -bottom-6 right-4 text-6xl text-pink-400 font-serif"
              aria-hidden="true"
            >
              ”
            </span>
          </motion.div>

          {/* Right Side - Image with Blob */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="relative w-48 h-48 sm:w-64 sm:h-64 lg:w-72 lg:h-72 group flex-shrink-0"
          >
            <svg
              viewBox="0 0 200 200"
              xmlns="http://www.w3.org/2000/svg"
              className="absolute w-full h-full -z-10"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="#f9a8d4"
                d="M47.4,-65.6C60.4,-55.6,68.8,-39.5,72.8,-22.6C76.7,-5.7,76.1,11.9,68.5,25.5C61,39.1,46.5,48.6,31.4,58.6C16.3,68.6,0.7,79.1,-13.5,76.4C-27.6,73.7,-40.3,57.8,-51.1,43C-61.8,28.2,-70.6,14.1,-70.3,-0.4C-70.1,-14.9,-60.8,-29.8,-48.8,-39.5C-36.9,-49.2,-22.4,-53.8,-7.4,-60.6C7.5,-67.5,15,-76.5,27.6,-77.1C40.3,-77.7,53.7,-69.8,47.4,-65.6Z"
                transform="translate(100 100)"
              />
            </svg>
            <img
              src={cloudinaryImageUrl}
              alt="PTA event showing parents and teachers collaborating"
              loading="lazy"
              width="600"
              height="600"
              className="w-full h-full object-cover rounded-2xl shadow-xl ring-4 ring-pink-200 
              transition duration-300 group-hover:ring-pink-300"
              decoding="async"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default React.memo(PTA);
